// extracted by mini-css-extract-plugin
export var container = "non-profits-section-module--container--13DSd";
export var wrapper = "non-profits-section-module--wrapper--2G72u";
export var highlight = "non-profits-section-module--highlight--12vhI";
export var organization = "non-profits-section-module--organization--2ii9H";
export var counties = "non-profits-section-module--counties--1r-iK";
export var phone = "non-profits-section-module--phone--3Si_C";
export var website = "non-profits-section-module--website--MJAKd";